import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import {
  CustomerModel,
  LocationModel,
  LocationCreateModel,
  TypeLocationModel,
  TypeLocationListModel,
  FiltersModel,
} from '@kanzi-apes/kanzi-models';
import {
  UntypedFormGroup,
  Validators,
  UntypedFormBuilder,
} from '@angular/forms';
import { LocationService } from '@kanzi-apes/kanzi-locations';
import * as fromCustomer from '@kanzi-apes/kanzi-customer';
import * as fromLocations from '../../reducers';
import * as Locations from '../../actions';
import { FURNISHINGS } from '@kanzi-apes/kanzi-floormap-ui';
import { EnvironmentService } from '@kanzi-apes/kanzi-utils';
import { AutoCompleteSelectEvent } from 'primeng/autocomplete';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'app-location-form',
    templateUrl: './location-form.component.html',
    styleUrls: ['./location-form.component.scss'],
    standalone: false
})
export class LocationFormComponent implements OnInit, OnChanges {
  @Input() LocationEdit: LocationModel | null;
  customerSelected$: Observable<CustomerModel | null> = this.store.pipe(
    select(fromCustomer.getCustomerSelected)
  );
  isPending$: Observable<boolean> = this.store.pipe(
    select(fromLocations.getLocationLoading)
  );
  LocationForm: UntypedFormGroup = this.fb.group({
    name: ['', Validators.required],
    display_name: ['', Validators.required],
    external_id: [''],
    description: ['', Validators.required],
    parent_id: ['', Validators.required],
    type_id: [''],
  });
  locationParentId: LocationModel | null = null;
  locationType: TypeLocationModel | null = null;
  locationParentType: TypeLocationModel | null = null;
  LocaionIcon = FURNISHINGS;
  iconLocationSelected: any | null = null;
  Location: LocationCreateModel = {
    name: '',
    display_name: '',
    external_id: '',
    description: '',
    parent_id: 0,
    type_id: 0,
    customer_ids: [],
    properties: null,
    params: null,
  };
  Locations$ = this.store.pipe(select(fromLocations.getLocationsList));
  Locations: LocationModel[] = [];
  customer_id = 0;
  typeLocations$: Observable<TypeLocationModel[]> | null = null;
  parentTypeLocations$: Observable<TypeLocationModel[]> | null = null;
  filterLocation: FiltersModel = { page: 1, page_size: 20 };
  showIcon: boolean;
  showListIcon = false;

  constructor(
    private locationService: LocationService,
    private fb: UntypedFormBuilder,
    private store: Store<fromLocations.State>,
    private envService: EnvironmentService
  ) {
    this.LocationEdit = null;
    this.showIcon =
      this.envService.environment?.configModules?.iconLocation ?? false;
  }

  ngOnInit() {
    this.Locations$.subscribe((list) => {
      if (list) {
        this.Locations = list.results;
      }
    });
    this.customerSelected$.subscribe((customer) => {
      if (customer) {
        this.Location.customer_ids = [customer.id];
        this.customer_id = customer.id;
        const filter = {
          page: 1,
          page_size: 20,
          customer_id: customer.id,
        };
        this.typeLocations$ = this.locationService
          .getlocationTypes(filter)
          .pipe(
            map((typelocations: TypeLocationListModel) => {
              return typelocations.results;
            })
          );
        this.store.dispatch(new Locations.LoadList(filter));
      }
    });
  }
  ngOnChanges(changes: import('@angular/core').SimpleChanges) {
    if (
      changes['LocationEdit'] &&
      this.LocationEdit &&
      (this.LocationEdit.customers || this.LocationEdit?.customer)
    ) {
      const customer: CustomerModel[] = this.LocationEdit.customers
        ? this.LocationEdit.customers
        : (this.LocationEdit.customer as CustomerModel[]);
      this.locationParentId = this.LocationEdit.parent;
      this.locationType = this.LocationEdit.type;
      const location: LocationCreateModel = {
        customer_ids: Array.from(customer, (customer) => Number(customer.id)),
        parent_id: this.locationParentId
          ? this.locationParentId.id
            ? this.locationParentId.id
            : 0
          : 0,
        name: this.LocationEdit.name,
        display_name: this.LocationEdit.display_name,
        external_id: this.LocationEdit.external_id,
        description: this.LocationEdit.description,
        type_id: this.locationType.id,
        id: this.LocationEdit.id,
      };
      this.Location = location;
      this.LocationForm.patchValue({
        ...this.Location,
        type_id: this.LocationEdit.type,
        parent_id: this.LocationEdit.parent,
      });
    }
  }

  selectionIcon(event: any) {
    this.iconLocationSelected = event.value[0];
    this.Location.properties = {
      commentary: '',
      type: this.iconLocationSelected.title,
    };
    this.Location.params = {
      map_point: {
        x_position: 0,
        y_position: 0,
      },
    };
  }

  filterLocations(event: any) {
    const filter = {
      ...this.filterLocation,
      search: event.query,
    };

    // Agregar type_id si hay un locationParentType seleccionado
    if (this.locationParentType && this.locationParentType.id) {
      filter.type_id = this.locationParentType.id;
    }

    this.store.dispatch(new Locations.LoadList(filter));
  }

  filterTypeLocations(event: any) {
    this.typeLocations$ = this.locationService
      .getlocationTypes({
        page: 1,
        page_size: 20,
        search: event.query,
      })
      .pipe(
        map((typelocations: TypeLocationListModel) => typelocations.results)
      );
  }

  filterParentTypeLocations(event: any) {
    this.parentTypeLocations$ = this.locationService
      .getlocationTypes({
        page: 1,
        page_size: 20,
        search: event.query,
      })
      .pipe(
        map((typelocations: TypeLocationListModel) => typelocations.results)
      );
  }

  onSelectLocation(location: AutoCompleteSelectEvent) {
    this.Location.parent_id = location.value.id ? location.value.id : 0;
  }

  onSelectTypeLocation(typeLocation: AutoCompleteSelectEvent) {
    this.Location.type_id = typeLocation.value.id;
  }

  onSelectParentTypeLocation(typeLocation: AutoCompleteSelectEvent) {
    this.filterLocation = {
      ...this.filterLocation,
      customer_id: this.customer_id,
      type_id: typeLocation.value.id,
    };
    this.store.dispatch(new Locations.LoadList(this.filterLocation));
  }

  onSubmit() {
    if (this.LocationEdit) {
      this.store.dispatch(new Locations.Edit(this.Location));
    } else {
      this.store.dispatch(new Locations.Create(this.Location));
    }
    this.Location = {
      name: '',
      display_name: '',
      external_id: '',
      description: '',
      parent_id: 0,
      type_id: 0,
      customer_ids: [],
      properties: null,
      params: null,
    };
    this.iconLocationSelected = null;
  }
}
